import PropTypes from "prop-types";

import React, {
	Component
} from "react";
import {
	View,
} from "react-native";

import ListAdd from "ae-base/List/ListAdd";
var inputStyle = {
	display: "none",
};

export default class FileAddWeb extends Component {
	constructor(props){
		super(props);

		this.handleChange = handleChange.bind(this);
	}

	render(){
		var context = this.context;
		var props = this.props;
		var title = props.title;
		var videoEnabled = props.videoEnabled;
		var pdfEnabled = props.pdfEnabled;
		var audioEnabled = props.audioPlayerEnabled || props.audioRecorderEnabled;
		var accept = "image/*";
		if(videoEnabled)
			accept = accept + ",video/*";
		if(pdfEnabled)
			accept = accept + ",application/pdf";
		if(audioEnabled)
			accept = accept + ",audio/*";
		var id = context.id_prefix + "fileselect_" + props.title;
		return (
			<View>
				<label htmlFor={id}>
					<ListAdd title={title} />
				</label>
				<input style={inputStyle} type="file" id={id} onChange={this.handleChange} accept={accept} capture="camera" />
			</View>
		);
	}
}

function handleChange(event) {
	var target = event.target;
	var files = target.files;
	if(!files || !files.length) return;
	var newFile = files[0];

	var onAdd = this.props.onAdd;
	if(onAdd) onAdd(newFile);
}

FileAddWeb.contextTypes = {
	id_prefix: PropTypes.string,
};
